import React from 'react'
import { Layers } from 'lucide-react'
import GenericTabelaPage from '../../components/tabelas/GenericTabelaPage'
import { linhasApi } from '../../api/tabelasBasicas'

const LinhasPage: React.FC = () => (
  <GenericTabelaPage
    titulo="Linhas de Produtos"
    breadcrumb="Tabelas › Básicas"
    icon={<Layers size={17} />}
    cdMaxLen={4}
    nmMaxLen={100}
    api={linhasApi}
  />
)

export default LinhasPage
